module.exports = __webpack_public_path__ + "static/media/GratitudeGREEK.4dd95542.vtt";